import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CalendarOptions, EventApi, FullCalendarComponent } from '@fullcalendar/angular';
import { Subscription } from 'rxjs';
import { DiaryModalComponent } from 'src/app/modal/diary-modal/diary-modal.component';
import { AuthService } from 'src/app/service/auth/auth.service';
import { CourtService } from 'src/app/service/common/court.service';
import { HomeService } from 'src/app/service/common/home.service';
import { UserType } from 'src/app/service/common/interface';
import { MessageService } from 'src/app/service/common/message.service';
import { SupportService } from 'src/app/service/common/support.service';
import { BarristerService } from 'src/app/service/pages/barrister.service';

@Component({
  selector: 'app-diary',
  templateUrl: './diary.component.html',
  styleUrls: ['./diary.component.css']
})
export class DiaryComponent implements OnInit {

  private _subs : Subscription = new Subscription();
  dateEvent : any[] = [];
  diaryFilter : {
    entryType : string,
    caseTypeId : string,
    clientTypeId : string,
    courtId : string,
    fundingTypeId : string,
    courtBundleReceived : string,
    attendanceNoteReceived : string,
    paymentReceived : string,
    barristerId : string,
    selectedId : string[]
  }
  caseTypes : any;
  courts : any;
  fundingTypes : any;
  barristers : any;
  userType : UserType = null;
  sidebarExpanded : boolean = false;
  calendarOptions: CalendarOptions = {
    datesSet: this.handleEvents.bind(this),
    initialView: 'dayGridMonth',
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,dayGridWeek,dayGridDay'
    },
    weekends: true,
    eventClick: this.handleEventClick.bind(this),
    locale: 'en-GB',
    dayMaxEvents: 8, // Show first 8 events, "Show More" appears for 9+
    events: []
  };
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;

  constructor(
    public datepipe: DatePipe,
    private router : Router,
    private auth : AuthService,
    private supportService : SupportService,
    private barristerService : BarristerService,
    private courtService : CourtService,
    private homeService : HomeService
  ) {

    this.diaryFilter = {
      entryType : "all",
      caseTypeId : "all",
      clientTypeId : "all",
      courtId : "all",
      fundingTypeId : "all",
      courtBundleReceived : "all",
      attendanceNoteReceived : "all",
      paymentReceived : "all",
      barristerId : "selected",
      selectedId : []
    }

    this._subs.add(
      this.supportService.getNames('caseTypes').subscribe(res => {
        this.caseTypes = res.data;
      })
    )
    this._subs.add(
      this.supportService.getNames('fundingTypes').subscribe(res => {
        this.fundingTypes = res.data;
      })
    )
    this._subs.add(
      this.barristerService.getBarristers('Solicitor', '1').subscribe(res =>{
        this.barristers = res.data;
      })
    )
    this._subs.add(
      this.courtService.getCourts('1').subscribe(res =>{
        this.courts = res.data;
      })
    )

    if(this.auth.getUserType()){
      this.auth.getUserType().subscribe(res=>{
        this.userType = res;
        if(this.userType.userTypeId == 2){
          // For barristers, set barristerId directly to their ID for proper filtering
          this.diaryFilter.barristerId = this.userType.barristerId.toString();
          this.diaryFilter.selectedId = [];
        }else{
          this.diaryFilter.barristerId = 'all';
          this.diaryFilter.selectedId = [];
        }

      });
    }
  }

  handleEvents(event: EventApi | any): void {
    if (this.calendarComponent) {
      this.loadEvents();
    }
  }

  ngOnInit(): void {}

  ngAfterViewInit(){
    this.loadEvents();
  }

  setCalenderDate($event){
    this.calendarComponent.getApi().gotoDate( $event.target.value);
    this.calendarComponent.getApi().changeView('dayGridDay');
  }

  clearFilters(){
    this.diaryFilter = {
      entryType : "all",
      caseTypeId : "all",
      clientTypeId : "all",
      courtId : "all",
      fundingTypeId : "all",
      courtBundleReceived : "all",
      attendanceNoteReceived : "all",
      paymentReceived : "all",
      barristerId : "all",
      selectedId : []
    }
    this.loadEvents();
  }

  async setBarristerId(id){
    if(id){
      const index = this.diaryFilter.selectedId.indexOf(id);
      if(index === -1){
        this.diaryFilter.selectedId.push(id);
      } else {
        this.diaryFilter.selectedId.splice(index, 1);
      }

      if(this.diaryFilter.selectedId.length === 0){
        this.diaryFilter.barristerId = 'all';
      } else {
        this.diaryFilter.barristerId = 'selected';
      }
    }
  }

  updateBarristerId(id){
    this.setBarristerId(id);
    this.loadEvents();
  }

  loadEvents(){
    if (this.calendarComponent) {
      let startDate = this.datepipe.transform(this.calendarComponent.getApi().view.activeStart, 'yyyy-MM-dd');
      let endDate = this.datepipe.transform(this.calendarComponent.getApi().view.activeEnd, 'yyyy-MM-dd');
      let currentView = this.calendarComponent.getApi().view.type;
      let dayMaxEvents = currentView === 'dayGridMonth' ? 8 : 100; // Show "More" for month, all for week/day

      // Set header format based on view type
      let headerFormat: any;
      if (currentView === 'dayGridMonth') {
        headerFormat = { weekday: 'short' };
      } else {
        headerFormat = { weekday: 'short', day: 'numeric', month: 'numeric', omitCommas: true };
      }

      let diaryArray = this.convertToArray();
      diaryArray.push(startDate);
      diaryArray.push(endDate);

      this._subs.add(
        this.homeService.getDiaryCounts(diaryArray).subscribe(res => {
          let allEvents = res.data || [];

          // Frontend filtering based on user role
          let filteredEvents = this.filterEventsByUserRole(allEvents);

          this.dateEvent = filteredEvents;
          const sortedEvents = this.sortEventsForDisplay(filteredEvents);

          this.calendarOptions = {
            datesSet: this.handleEvents.bind(this),
            initialView: 'dayGridMonth',
            headerToolbar :{
              left : 'prev,next today',
              center : 'title',
              right : 'dayGridMonth,dayGridWeek,dayGridDay'
            },
            weekends : true,
            eventClick : this.handleEventClick.bind(this),
            dayMaxEvents: dayMaxEvents,
            locale: 'en-GB',
            dayHeaderFormat: headerFormat,
            events: sortedEvents
          }
        })
      )
    }
  }

  convertToArray(){
    let temp = [];
    temp.push(this.diaryFilter.entryType);
    temp.push(this.diaryFilter.caseTypeId);
    temp.push(this.diaryFilter.clientTypeId);
    temp.push(this.diaryFilter.courtId);
    temp.push(this.diaryFilter.fundingTypeId);
    temp.push(this.diaryFilter.courtBundleReceived);
    temp.push(this.diaryFilter.attendanceNoteReceived);
    temp.push(this.diaryFilter.paymentReceived);
    temp.push(this.diaryFilter.barristerId);
    temp.push(this.diaryFilter.selectedId);
    return temp;
  }

  // Frontend filtering based on user role
  filterEventsByUserRole(allEvents: any[]): any[] {
    if (!this.userType) {
      return allEvents; // Return all events if user type not loaded yet
    }

    // Admin login (userTypeId: 1, barristerId: null) - show ALL events
    if (this.userType.userTypeId == 1 && !this.userType.barristerId) {
      return allEvents;
    }

    // Barrister login (userTypeId: 2, barristerId: specific ID) - show only their events
    if (this.userType.userTypeId == 2 && this.userType.barristerId) {
      return allEvents.filter(event => {
        // Filter events where barrister_id matches the logged-in barrister's ID
        return event.barrister_id == this.userType.barristerId;
      });
    }

    // Default: return all events
    return allEvents;
  }

  sortEventsForDisplay(events: any[]): any[] {
    return events.sort((a, b) => {
      const aStart = new Date(a.start).toISOString().split('T')[0];
      const aEnd = a.end ? new Date(a.end).toISOString().split('T')[0] : aStart;
      const bStart = new Date(b.start).toISOString().split('T')[0];
      const bEnd = b.end ? new Date(b.end).toISOString().split('T')[0] : bStart;

      const aIsMultiDay = aStart !== aEnd;
      const bIsMultiDay = bStart !== bEnd;

      if (aIsMultiDay && !bIsMultiDay) return -1;
      if (!aIsMultiDay && bIsMultiDay) return 1;
      return new Date(a.start).getTime() - new Date(b.start).getTime();
    });
  }

  toggleSidebar() {
    this.sidebarExpanded = !this.sidebarExpanded;
    // Add/remove class to body for header positioning
    if (this.sidebarExpanded) {
      document.body.classList.add('sidebar-expanded');
    } else {
      document.body.classList.remove('sidebar-expanded');
    }
    // Trigger calendar resize after sidebar transition (0.4s)
    setTimeout(() => {
      if (this.calendarComponent) {
        this.calendarComponent.getApi().updateSize();
      }
    }, 450);
  }

  handleEventClick(args){
    if(args.event.extendedProps.modelName == 'holiday'){
      this.router.navigateByUrl("pages/barristers/view/"+args.event.id+"/holidays");
    }else{
      this.router.navigateByUrl("/pages/cases/view/"+args.event.id);
    }
  }
}
